const article = {
	slug: "token-optimizing-claude-code",
	title: "Uber Didn't Overspend on AI. Their Engineers Did.",
	date: "29 May 2026",
	updated: null,
	description: "Engineers sabotage AI coding ROI through reflexive over-use. A one-command open-source tool intercepts before the model runs and asks whether you could do the task yourself in ten seconds.",
	keywords: ["AI cost governance", "token optimization", "AI engineering", "Claude Code"],
	tldr: "The ROI on AI coding tools is real, and so is the tax on reflex. Cost governance means catching the ten-second tasks before they get handed to an expensive model.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, May 2026.",
	provenanceUrl: null,
	series: null,
	artifact: "token-cost-calculator",
	markdown: `Uber didn't overspend on AI.

Their engineers did.

Uber burned their entire 2026 AI coding budget in four months. Microsoft pulled most of their Claude Code licenses. Uber's COO said the ROI link "is not there yet."

The ROI is there. The discipline isn't.

## A $0.033 reflex

I caught myself in the same habit. Asked Claude Code to write a note about what I just changed. Not because I didn't know what to write. Because it felt faster than typing.

That's a $0.033 reflex. Harmless once. Expensive at scale.

## Intercepting before the AI starts

So I built a tool that intercepts before the AI starts. It asks one question: can you do this in 10 seconds yourself? If yes, it shows you how and steps aside.

Running this across my team means the habit stops at me, not with me.

It catches the "I don't feel like typing" reflexes. Small tasks handed to a $15/million-token model because doing it yourself felt like too much effort.

Two reflexes it catches most often:

**Describing your own changes.** You were there. You know what you did. That's a sentence, not an AI task.

**Finding a word across your codebase.** Your editor does this in under a second. The AI reads your entire project to answer the same question.

## Knowing when not to

The ROI on AI coding tools is real. The tax on reflex is real too.

The engineers who come out ahead aren't the ones who used Claude least.

They knew when not to.

Open source, one-command install: [github.com/swapniltamse/token-optimizer](https://github.com/swapniltamse/token-optimizer)`,
};

export default article;
